import { game } from '../main';

interface IGameConfig {
  grid: IGridConfig;
  shooter: IShooterConfig;
}

export interface IGridConfig {
  x: number;
  y: number;
  sizeW: number;
  sizeH: number;
  mobile: boolean;
  fillTo: number;
}

export interface IShooterConfig {
  x: number;
  y: number;
  chances: number;
}

export function getGameConfig(): IGameConfig {
  if (game.horizontal) {
    return {
      grid: {
        x: 15,
        y: 20,
        sizeW: 17,
        sizeH: 12,
        mobile: false,
        fillTo: 9,
      },
      shooter: {
        x: 458,
        y: 700,
        chances: 5 - game.gameDifficultyLevel,
      },
    };
  } else {
    return {
      grid: {
        x: 57,
        y: 130,
        sizeW: 10,
        sizeH: 13,
        mobile: true,
        fillTo: 7,
      },
      shooter: {
        x: 324,
        y: 900,
        chances: 5 - game.gameDifficultyLevel,
      },
    };
  }
}